//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from 'vuex';
import Checkbox from '../common/svg/Checkbox.vue';
import LandingSurveyModal from './components/modals/Brooks1914RegistrationSurveyModal.vue';
import LandingTermsConditionsModal from './components/modals/Brooks1914RegistrationTermsConditionsModal.vue';
import LandingAccountModal from './components/modals/Brooks1914RegistrationAccountModal.vue';
import Logo from '../common/svg/Logo';
import ErrorDisplay from '../common/ErrorDisplay.vue';
import convert from 'convert-units';

export default {
  name: 'Brooks1914Registration',
  components: {
    Checkbox,
    LandingSurveyModal,
    LandingTermsConditionsModal,
    LandingAccountModal,
    Logo,
    ErrorDisplay,
  },
  created() {
    this.pageTitle = 'Landing Page';
    this.description = 'Description';
    this.instructionsTitle = '3 Steps to Register';
    // this.survey = new BrooksSurvey();
  },
  data() {
    return {
      loading: false,
      pageTitle: '',
      description: '',
      instructionsTitle: '',
      couponCode: 'b1914_2020',
      survey: false,
      stepOneCompleted: false,
      stepTwoCompleted: false,
      stepThreeCompleted: false,
      error: null,
      pageState: '',
    };
  },
  methods: {
    ...mapActions(['initialize', 'updatePayment']),
    async registerNow() {
      this.pageState = 'Registering to event...';
      this.loading = true;
      this.error = null;
      try {
        await this.$api.registerUserWithEvent({
          emailAddress: this.loggedInMember.emailAddress,
          firstName: this.survey.firstName,
          lastName: this.survey.lastName,
          gender: this.survey.data.question4 === 'Male' ? 'M' : 'F',
          birthDate: this.survey.data.question3,
        }, 'fa20fea9-c14a-4596-8fe3-10e56e6c6033');
        await this.$api.saveSurvey(this.survey.data, '214e0b6a-14d3-4ce9-92a0-d5a110ecd974', this.loggedInMember.awsCognitoSub);
        this.pageState = 'Loading Data...';

        await this.initialize();
        this.pageState = 'Success!';
        if (this.stepThreeCompleted === 'new') {
          const memberData = this.loggedInMember;
          memberData.firstName = this.survey.firstName;
          memberData.lastName = this.survey.lastName;
          memberData.gender = this.survey.data.question4 === 'Male' ? 'M' : 'F';
          memberData.height = convert(this.survey.data.question5).from('in').to('m');
          memberData.weight = convert(this.survey.data.question6).from('lb').to('kg');
          await this.$container.memberService.updateMember(memberData);
          window.open('https://www.pwrlab.com/connected-events/brooks-1914/b1914-first-steps/', '_blank');
          await this.$router.push({ name: 'setup' });
        } else {
          await this.updatePayment({
            member_id: this.loggedInMember.memberId,
            coupon: this.couponCode,
          });
          window.open('https://app.pwrlab.com', '_blank');
          window.location.href = 'https://www.pwrlab.com/connected-events/brooks-1914/b1914-first-steps/';
        }
        this.error = null;
      } catch (error) {
        this.handle_error(error);
      } finally {
        this.loading = false;
      }
    },
    handle_error(error) {
      if (error.response && error.response.data) {
        this.error = error.response.data;
      } else {
        this.error = error;
      }
      this.loading = false;
    },
  },
  computed: {
    ...mapGetters(['user', 'loggedInMember']),
    isStepOneCompleted() {
      return this.stepOneCompleted;
    },
    isStepTwoCompleted() {
      return this.stepTwoCompleted;
    },
    isStepThreeCompleted() {
      return this.stepThreeCompleted;
    },
    isRegisterButtonDisabled() {
      return !(
        this.survey &&
        this.stepTwoCompleted &&
        this.stepThreeCompleted
      );
    },
  },
};
